import React, { useState, Fragment } from 'react';
import MenuItem from '@mui/material/MenuItem';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { FlexDiv, SpaceBetweenDiv } from './design-system/containers';
import Popover from '@mui/material/Popover';
import CircularProgress from '@mui/material/CircularProgress';

// example of usage:
{
    /* <NestedMenuItem
    text={'Download assessment'}
    loading={isPackageDownloading}
    items={[
        {
            text: 'SCORM 1.2',
            props: {
                onClick: () => {
                    handleDownloadPackage('scorm12');
                },
            },
        },
        {
            text: 'SCORM 2004 3rd Edition',
            props: {
                onClick: () => {
                    handleDownloadPackage('scorm2004');
                },
            },
        },
        {
            text: 'cmi5',
            props: {
                onClick: () => {
                    handleDownloadPackage('cmi5');
                },
            },
        },
    ]}
/>; */
}

export const NestedMenuItem = ({ items, text, loading = false }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClickAway = () => {
        setAnchorEl(null);
    };

    const dropdownOpen = Boolean(anchorEl);

    const dropdownItems =
        items &&
        items.map((x, i) => (
            <MenuItem key={i} {...x.props}>
                {x.text}
            </MenuItem>
        ));

    return (
        <Fragment>
            <MenuItem onClick={handleClick} selected={dropdownOpen}>
                <SpaceBetweenDiv gap={8} $noWrap>
                    {text}
                    {loading ? (
                        <CircularProgress
                            size={20}
                            thickness={4}
                            color="inherit"
                        />
                    ) : (
                        <NavigateNextIcon fontSize="small" />
                    )}
                </SpaceBetweenDiv>
            </MenuItem>
            <Popover
                open={dropdownOpen}
                anchorEl={anchorEl}
                onClose={handleClickAway}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                elevation={1}
            >
                <FlexDiv
                    column
                    backgroundColor="white"
                    borderRadius={4}
                    onClick={handleClickAway}
                    py={8}
                >
                    {dropdownItems}
                </FlexDiv>
            </Popover>
        </Fragment>
    );
};
